import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=3a8a8340&scoped=true&"
import script from "./Views.vue?vue&type=script&lang=js&"
export * from "./Views.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a8340",
  null
  
)

export default component.exports